import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import TextInput from '../../pages/components/inputs/TextInput';
import { Icon } from '../Component';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import * as app_consts from "../../utils/app_consts";
import { fail_update_budget_allocation, loading_update_budget_allocation, reset_update_budget_allocation, success_update_budget_allocation } from '../../reducers/auth_tenant/update_budget_allocation_Slice';
import { UPDATE_BUDGET_ALLOCATION_ERROR_MSG, UPDATE_BUDGET_ALLOCATION_SUCCESS_MSG } from '../../utils/error_success_messages';
import { TENANT_UPDATE_SALES_REP_ALLOCATED_BUDGET_VALUE_API } from '../../api/api_data';
import { messageToast } from '../../utils/Utils';
import { useSelector } from 'react-redux';

const initialState = { id: "", new_value: "", reason: "" };

const TenantUpdateSalesRepBudgetAllocationValueModal = ({ isOpen, closeModal, data, tenant_info, user_info, successFunction }) => {

 const [page_data, setPageData] = useState(data);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [formData, setFormData] = useState(initialState);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 useEffect(() => {
  setPageData(data);
  setOpen(isOpen);
  setFormData({ ...formData, id: data?.id, new_value: "", reason: "" });
 }, [data, isOpen]);

 const handleUpdateBudgetAllocation = () => {
  setError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_update_budget_allocation, success_update_budget_allocation, fail_update_budget_allocation, UPDATE_BUDGET_ALLOCATION_ERROR_MSG, UPDATE_BUDGET_ALLOCATION_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_SALES_REP_ALLOCATED_BUDGET_VALUE_API}`, formData));
 };

 // Listen
 const update_budget_allocation_listener = useSelector((state) => state.update_budget_allocation.update_budget_allocation);

 useEffect(() => {
  if (update_budget_allocation_listener.status !== app_consts.IDLE)
  {
   if (update_budget_allocation_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (update_budget_allocation_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(update_budget_allocation_listener.message);
     messageToast(update_budget_allocation_listener.message, app_consts.FAIL);
    } else if (update_budget_allocation_listener.status === app_consts.SUCCESS)
    {
     successFunction();
     closeModal();
    }
    dispatch(reset_update_budget_allocation());
   }
  }
 }, [update_budget_allocation_listener]);


 return (
  <>
   < Modal isOpen={open} className="modal-dialog-centered" size={"md"} >
    <ModalHeader toggle={loading ? "" : closeModal}>Update Sales Rep Budget Allocation Value</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="New Value (ZMW)"
       type="number"
       id_val="new_value"
       value={formData?.new_value}
       colSize="12"
       required
       name="new_value"
       handleChange={handleChange}
      />
      <TextInput
       label="Update Reason"
       type="text"
       id_val="reason"
       value={formData?.reason}
       colSize="12"
       name="reason"
       required
       handleChange={handleChange}
      />
     </Row>
     {error && (
      <div className="my-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {error}{" "}
       </Alert>
      </div>
     )}
     <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
      <Button onClick={handleUpdateBudgetAllocation} disabled={
       (loading) ||
       !(formData?.new_value && formData?.id && formData?.reason)
      } color="primary">
       {loading ? <Spinner size="sm" color="light" /> : "Update Budget Allocation Value"}
      </Button>
     </Col>
    </ModalBody>
   </Modal>

  </>
 );
};

export default TenantUpdateSalesRepBudgetAllocationValueModal;